import { useNavigate } from "react-router-dom";
import Logo from "../../../assets/img/logo.png";
// import ProfileImg from "../../../assets/img/profile-img.jpg";
import { useContext, useEffect, useState } from "react";
import User from "../../../models/user";
import UserContext from "../../../contexts/userContext";
import SubscriptionType from "../../../models/subscriptionType";
import SubscriptionContext from "../../../contexts/subscriptionContext";
import SubscriptionContextModel from "../../../contexts/subscriptionContextModel";
import appSettings from "../../../appSettings";

const Header: React.FC = () => {
  const navigate = useNavigate();

  const user = useContext<User | undefined>(UserContext);
  const { subscription } =
    useContext<SubscriptionContextModel>(SubscriptionContext);

  const [firstName, setFirstName] = useState<string>();
  const [lastName, setLastName] = useState<string>();

  const [currentSubscriptionType, setCurrentSubscriptionType] =
    useState<string>(SubscriptionType.None);

  useEffect(() => {
    if (!user) {
      return;
    }

    setFirstName(user.firstName);
    setLastName(user.lastName);

    setCurrentSubscriptionType(subscription.subscriptionType);

    user.onUserInfoChanged = () => {
      setFirstName(user.firstName);
      setLastName(user.lastName);
    };
  }, [user, subscription]);

  const onLogoClick = () => {
    navigate("/");
  };

  const onLogout = () => {
    navigate("/logout");
  };

  return (
    <>
      {/* <!-- Header --> */}
      <header className="header">
        <div className="version">{appSettings.appVersion}</div>
        {/* <!-- Header Left --> */}
        <div className="header-left">
          <div
            className="header-logo"
            style={{ cursor: "pointer" }}
            onClick={onLogoClick}
          >
            <img src={Logo} alt="Work Order Direct" />
            <span>Work Order Direct</span>
          </div>
          <button className="sidebar-toggle" title="Toggle Sidebar">
            <i className="bi bi-list"></i>
          </button>
        </div>

        {/* <!-- Header Search (Desktop) --> */}
        <div className="header-search">
          <form
            className="search-form"
            action="search-results.html"
            method="GET"
          >
            <i className="bi bi-search search-icon"></i>
            <input
              type="search"
              name="q"
              placeholder="Search..."
              autoComplete="off"
            />
          </form>
        </div>

        {/* <!-- Header Right --> */}
        <div className="header-right">
          {/* <!-- Desktop Actions (hidden on mobile, shown in mobile menu) --> */}
          <div className="header-actions-desktop">
            {/* <!-- Apps Dropdown --> */}
            {/* <div className="header-action dropdown apps-dropdown">
              <button
                className="dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                title="Apps"
              >
                <i className="bi bi-grid-3x3-gap"></i>
              </button>
              <div className="dropdown-menu dropdown-menu-end apps-menu">
                <div className="apps-menu-header">
                  <h6>Quick Access</h6>
                </div>
                <div className="apps-grid">
                  <a href="index.html" className="apps-item">
                    <div className="apps-item-icon primary">
                      <i className="bi bi-speedometer2"></i>
                    </div>
                    <span className="apps-item-title">Dashboard</span>
                  </a>
                  <a href="apps-kanban.html" className="apps-item">
                    <div className="apps-item-icon success">
                      <i className="bi bi-kanban"></i>
                    </div>
                    <span className="apps-item-title">Projects</span>
                  </a>
                  <a href="apps-chat.html" className="apps-item">
                    <div className="apps-item-icon info">
                      <i className="bi bi-chat-square-text"></i>
                    </div>
                    <span className="apps-item-title">Messages</span>
                  </a>
                  <a href="apps-contacts.html" className="apps-item">
                    <div className="apps-item-icon warning">
                      <i className="bi bi-person-lines-fill"></i>
                    </div>
                    <span className="apps-item-title">Contacts</span>
                  </a>
                  <a href="apps-todo.html" className="apps-item">
                    <div className="apps-item-icon danger">
                      <i className="bi bi-check2-square"></i>
                    </div>
                    <span className="apps-item-title">Tasks</span>
                  </a>
                  <a href="apps-calendar.html" className="apps-item">
                    <div className="apps-item-icon secondary">
                      <i className="bi bi-calendar-event"></i>
                    </div>
                    <span className="apps-item-title">Calendar</span>
                  </a>
                  <a href="apps-file-manager.html" className="apps-item">
                    <div className="apps-item-icon primary">
                      <i className="bi bi-folder2-open"></i>
                    </div>
                    <span className="apps-item-title">Files</span>
                  </a>
                  <a href="apps-email.html" className="apps-item">
                    <div className="apps-item-icon info">
                      <i className="bi bi-envelope"></i>
                    </div>
                    <span className="apps-item-title">Email</span>
                  </a>
                  <a href="settings.html" className="apps-item">
                    <div className="apps-item-icon muted">
                      <i className="bi bi-gear"></i>
                    </div>
                    <span className="apps-item-title">Settings</span>
                  </a>
                </div>
              </div>
            </div> */}

            {/* <!-- Theme Toggle --> */}
            {/* <button className="header-action theme-toggle" title="Toggle Theme">
              <i className="ph ph-moon theme-icon-dark"></i>
              <i className="ph ph-sun theme-icon-light"></i>
            </button> */}

            {/* <!-- Language Selector --> */}
            {/* <div className="header-action dropdown language-dropdown">
              <button
                className="dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                title="Language"
              >
                <span className="lang-flag">🇺🇸</span>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <a className="dropdown-item active" href="#">
                    <span className="lang-flag">🇺🇸</span>
                    <span>English</span>
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    <span className="lang-flag">🇪🇸</span>
                    <span>Español</span>
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    <span className="lang-flag">🇫🇷</span>
                    <span>Français</span>
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    <span className="lang-flag">🇩🇪</span>
                    <span>Deutsch</span>
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    <span className="lang-flag">🇨🇳</span>
                    <span>中文</span>
                  </a>
                </li>
              </ul>
            </div> */}

            {/* <!-- Notifications --> */}
            <div className="header-action dropdown notification-dropdown">
              <button
                className="dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                title="Notifications"
              >
                <i className="bi bi-bell"></i>
                <span className="badge">3</span>
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <div className="notification-header">
                  <h6>Notifications</h6>
                  <span className="notification-count">3 new</span>
                </div>
                <div className="notification-list">
                  <a href="# " className="notification-item unread">
                    <div className="notification-avatar success">
                      <i className="bi bi-check-circle"></i>
                    </div>
                    <div className="notification-content">
                      <div className="notification-title">Order Completed</div>
                      <div className="notification-text">
                        Your order #12345 has been delivered successfully
                      </div>
                      <div className="notification-time">
                        <i className="bi bi-clock"></i>5 min ago
                      </div>
                    </div>
                  </a>
                  <a href="# " className="notification-item unread">
                    <div className="notification-avatar warning">
                      <i className="bi bi-exclamation-triangle"></i>
                    </div>
                    <div className="notification-content">
                      <div className="notification-title">
                        Low Storage Warning
                      </div>
                      <div className="notification-text">
                        Server storage is running low (85% used)
                      </div>
                      <div className="notification-time">
                        <i className="bi bi-clock"></i>1 hour ago
                      </div>
                    </div>
                  </a>
                  <a href="# " className="notification-item unread">
                    <div className="notification-avatar info">
                      <i className="bi bi-person-plus"></i>
                    </div>
                    <div className="notification-content">
                      <div className="notification-title">New Team Member</div>
                      <div className="notification-text">
                        Sarah Johnson joined the design team
                      </div>
                      <div className="notification-time">
                        <i className="bi bi-clock"></i>2 hours ago
                      </div>
                    </div>
                  </a>
                  <a href="# " className="notification-item">
                    <div className="notification-avatar primary">
                      <i className="bi bi-chat-left-text"></i>
                    </div>
                    <div className="notification-content">
                      <div className="notification-title">New Comment</div>
                      <div className="notification-text">
                        Mike commented on your post
                      </div>
                      <div className="notification-time">
                        <i className="bi bi-clock"></i>
                        Yesterday
                      </div>
                    </div>
                  </a>
                </div>
                <div className="notification-footer">
                  <a href="notifications.html">
                    View all notifications
                    <i className="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* <!-- User Dropdown --> */}
            <div className="header-action dropdown user-dropdown">
              <button
                className="dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {/* <img src={ProfileImg} alt="User" className="avatar" /> */}
                <i
                  className="bx bxs-user-circle avatar"
                  style={{ fontSize: "35px" }}
                ></i>
              </button>
              <div className="dropdown-menu dropdown-menu-end">
                <div className="user-dropdown-header">
                  {/* <img
                    src={ProfileImg}
                    alt="User"
                    className="user-dropdown-avatar"
                  /> */}
                  <i
                    className="bx bxs-user-circle user-dropdown-avatar"
                    style={{ fontSize: "45px", color: "white" }}
                  ></i>
                  <div className="user-dropdown-info">
                    <div className="user-dropdown-name">{`${firstName} ${lastName}`}</div>
                    {/* <div className="user-dropdown-role">Administrator</div> */}
                    <div className="user-dropdown-role">
                      {currentSubscriptionType} Subscription
                    </div>
                  </div>
                </div>
                <div className="user-dropdown-body">
                  <div
                    className="user-dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/work/profile")}
                  >
                    <i className="bi bi-person"></i>
                    <span>My Profile</span>
                  </div>
                  {/* <a className="user-dropdown-item" href="settings.html">
                    <i className="bi bi-gear"></i>
                    <span>Account Settings</span>
                  </a> */}
                  {/* <a className="user-dropdown-item" href="activity.html">
                    <i className="bi bi-clock-history"></i>
                    <span>Activity Log</span>
                  </a> */}
                </div>
                <div className="user-dropdown-footer">
                  <div
                    className="user-dropdown-logout"
                    style={{ cursor: "pointer" }}
                    onClick={onLogout}
                  >
                    <i className="bi bi-box-arrow-right"></i>
                    <span>Sign Out</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Mobile Actions (visible only on mobile) --> */}
          <div className="header-actions-mobile">
            {/* <!-- Search Toggle (Mobile) --> */}
            <button className="header-action search-toggle" title="Search">
              <i className="bi bi-search"></i>
            </button>

            {/* <!-- Mobile Menu Toggle --> */}
            {/* <button className="header-action mobile-menu-toggle" title="More">
              <i className="bi bi-three-dots-vertical"></i>
            </button> */}
          </div>
        </div>
      </header>

      {/* <!-- Mobile Search --> */}
      <div className="mobile-search">
        <form className="search-form" action="search-results.html" method="GET">
          <input
            type="search"
            name="q"
            placeholder="Search..."
            autoComplete="off"
          />
          <button type="submit">
            <i className="bi bi-search"></i>
          </button>
        </form>
      </div>

      {/* <!-- Mobile Header Menu --> */}
      <div className="mobile-header-menu">
        <div className="mobile-header-menu-content">
          {/* <!-- Theme Toggle --> */}
          <button
            className="mobile-menu-item theme-toggle"
            title="Toggle Theme"
          >
            <i className="ph ph-moon theme-icon-dark"></i>
            <i className="ph ph-sun theme-icon-light"></i>
            <span className="mobile-menu-label">Theme</span>
          </button>

          {/* <!-- Notifications --> */}
          <a href="notifications.html" className="mobile-menu-item">
            <i className="bi bi-bell"></i>
            <span className="badge">3</span>
            <span className="mobile-menu-label">Notifications</span>
          </a>

          {/* <!-- Profile --> */}
          <div
            className="mobile-menu-item"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/work/profile")}
          >
            <i className="bi bi-person"></i>
            <span className="mobile-menu-label">Profile</span>
          </div>

          {/* <!-- Settings (Account Settings) --> */}
          {/* <a href="settings.html" className="mobile-menu-item">
            <i className="bi bi-gear"></i>
            <span className="mobile-menu-label">Settings</span>
          </a> */}

          {/* <!-- Sign Out --> */}
          <div
            className="mobile-menu-item mobile-menu-item-danger"
            style={{ cursor: "pointer" }}
            onClick={onLogout}
          >
            <i className="bi bi-box-arrow-right"></i>
            <span className="mobile-menu-label">Sign Out</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
